<template>
  <transition name="modal">
    <div v-if="visible" class="modal-overlay" @click.self="onClose">
      <div class="modal">
        <transition name="fade">
          <div v-if="saving" class="saving-overlay">
            <div class="saving-spinner" />
            <div class="saving-text">正在下载中...</div>
          </div>
        </transition>
        <button type="button" class="btn-close" @click="onClose">×</button>
        <div ref="certDocumentRef" class="cert-document">
          <img
            v-if="result && result.images"
            :src="toProxyUrl(result.images)"
            alt=""
            class="cert-bg-img"
            crossorigin="anonymous"
          />
          <div class="cert-content" style="margin-top: 70px">
            <div class="cert-header">
              <div class="cert-title-main">智能AI数字人商城平台</div>
              <div class="cert-title-sub">计算机登记证书</div>
              <div
                v-if="result && result.certificate_sn"
                style="margin-right: 100px"
                class="cert-sn"
              >
                证书号: {{ result.certificate_sn }}
              </div>
            </div>
            <div class="cert-details" style="margin-left: 20px">
              <div v-if="result && result.software_name" class="cert-item">
                <span class="cert-label">软件名称:</span>
                <span class="cert-value">
                  {{ result.software_name }}
                  <span v-if="result.v_name" class="cert-version">{{ result.v_name }}</span>
                </span>
              </div>
              <div v-if="result && result.author" class="cert-item">
                <span class="cert-label">著作权人:</span>
                <span class="cert-value">{{ result.author }}</span>
              </div>
              <div class="cert-item">
                <span class="cert-label">权利取得方式:</span>
                <span class="cert-value">原始取得</span>
              </div>
              <div v-if="result && result.rights_scope" class="cert-item">
                <span class="cert-label">权利范围:</span>
                <span class="cert-value">{{ result.rights_scope }}</span>
              </div>
            </div>
            <div class="cert-legal">
              该数字人商城经过本平台审核，认定平台具备智能ai数字人商城属性;予以颁布证书，可前往gw.aiszrsc.cn查询
            </div>
            <div class="cert-footer">
              <div v-if="result && result.qr_code" class="cert-qr-wrap" style="margin-bottom: 20px">
                <img
                  :src="toProxyUrl(result.qr_code)"
                  alt="证书二维码"
                  class="cert-qr"
                  crossorigin="anonymous"
                />
              </div>
              <div class="cert-seal-area">
                <img
                  v-if="result && result.chapter_url"
                  :src="toProxyUrl(result.chapter_url)"
                  alt="印章"
                  class="cert-seal-img"
                  crossorigin="anonymous"
                />
                <div v-if="result && result.create_time" class="cert-date">{{ result.create_time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-actions">
          <button type="button" class="btn-save" :disabled="saving" @click="saveAsImage">
            {{ saving ? '保存中...' : '保存图片' }}
          </button>
          <button type="button" class="btn-close-bottom" @click="onClose">关闭</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { toPng } from 'html-to-image';
import { BACKEND_ORIGIN } from '@/config/api.js';

export default {
  name: 'CertificateResultModal',
  props: {
    visible: { type: Boolean, default: false },
    result: { type: Object, default: null }
  },
  data() {
    return {
      saving: false
    };
  },
  watch: {
    visible(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    toProxyUrl(url) {
      if (!url || typeof url !== 'string') return url;
      const resolved = url.startsWith('/') ? new URL(url, BACKEND_ORIGIN).href : url;
      try {
        const u = new URL(resolved);
        if (u.origin === window.location.origin) return resolved;
      } catch (e) {
        return url;
      }
      return `/api/proxy-image?url=${encodeURIComponent(resolved)}`;
    },
    waitForImages(el) {
      const imgs = el.querySelectorAll('img');
      return Promise.all(
        Array.from(imgs).map(
          (img) =>
            new Promise((resolve) => {
              if (img.complete) return resolve();
              const done = () => {
                img.removeEventListener('load', done);
                img.removeEventListener('error', done);
                resolve();
              };
              img.addEventListener('load', done);
              img.addEventListener('error', done);
              setTimeout(done, 5000);
            })
        )
      );
    },
    async saveAsImage() {
      const el = this.$refs.certDocumentRef;
      if (!el) return;
      this.saving = true;
      try {
        if (document.fonts && document.fonts.ready) {
          await document.fonts.ready;
        }
        await this.waitForImages(el);
        const dataUrl = await toPng(el, {
          pixelRatio: 2,
          cacheBust: true
        });
        const link = document.createElement('a');
        const sn = (this.result && this.result.certificate_sn) || 'certificate';
        link.download = `证书-${sn}.png`;
        link.href = dataUrl;
        link.click();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        alert('保存失败');
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10050;
  padding: 24px;
  box-sizing: border-box;
}
.modal {
  position: relative;
  font-family: 'STKaiti', 'KaiTi', '楷体', serif;
  background: #fff;
  border-radius: 12px;
  width: ~"min(560px, 95vw)";
  max-height: 95vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}
.btn-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  font-size: 0.8rem;
  color: #666;
  cursor: pointer;
  z-index: 10;
  line-height: 1;
}
.btn-close:hover {
  color: #333;
}
.cert-document {
  position: relative;
  background: linear-gradient(135deg, #e8f4fc 0%, #f0f8ff 100%);
  padding: 20px;
  aspect-ratio: 210 / 287;
  min-height: 360px;
  overflow: hidden;
}
.cert-bg-img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  z-index: 0;
}
.cert-content {
  position: relative;
  z-index: 1;
  padding: 0 20px 20px;
}
.cert-header {
  text-align: center;
  padding: 24px 0 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.cert-title-main {
  font-size: 0.6rem;
  font-weight: 900;
  color: #1a1a2e;
  letter-spacing: 2px;
}
.cert-title-sub {
  font-size: 0.55rem;
  font-weight: 900;
  color: #1a1a2e;
  margin-top: 14px;
  letter-spacing: 1px;
}
.cert-sn {
  font-size: 0.3rem;
  color: #444;
  font-weight: 900;
  margin-top: 20px;
  text-align: right;
}
.cert-details {
  padding: 20px 0 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.cert-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  font-size: 0.3rem;
  gap: 6px;
}
.cert-item:last-child {
  margin-bottom: 0;
}
.cert-label {
  font-weight: 900;
  flex-shrink: 0;
  width: 6.5em;
  color: #000;
  text-align: justify;
  line-height: 1.4;
}
.cert-label::after {
  content: '';
  display: inline-block;
  width: 100%;
  height: 0;
  overflow: hidden;
}
.cert-value {
  margin-left: 20px;
  font-weight: 900;
  flex: 1;
  color: #1a1a2e;
  word-break: break-all;
  min-width: 0;
}
.cert-version {
  display: block;
  margin-top: 4px;
  color: #555;
}
.cert-legal {
  font-weight: 900;
  font-size: 0.3rem;
  color: #000;
  line-height: 1.8;
  padding: 16px 20px;
  text-align: justify;
  text-indent: 2em;
}
.cert-footer {
  margin-top: -50px;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-top: 24px;
}
.cert-qr-wrap {
  margin-left: 60px;
  flex-shrink: 0;
}
.cert-qr {
  width: 80px;
  height: 80px;
  display: block;
}
.cert-seal-area {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.cert-seal-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  display: block;
}
.cert-date {
  font-weight: 900;
  font-size: 0.3rem;
  color: #000;
  margin-top: 12px;
}
.modal-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 20px 24px;
}
.btn-save {
  padding: 10px 32px;
  background: #fff;
  border: 1px solid #c7000b;
  border-radius: 6px;
  color: #c7000b;
  font-size: 0.5rem;
  cursor: pointer;
}
.btn-save:hover:not(:disabled) {
  background: #fff5f5;
}
.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.btn-close-bottom {
  padding: 10px 32px;
  background: #c7000b;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 0.5rem;
  cursor: pointer;
}
.btn-close-bottom:hover {
  background: #a00009;
}
.saving-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  z-index: 20;
  border-radius: 12px;
}
.saving-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e5e7eb;
  border-top-color: #c7000b;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
.saving-text {
  font-size: 0.95rem;
  color: #666;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s;
}
.modal-enter-active .modal,
.modal-leave-active .modal {
  transition: transform 0.2s;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
.modal-enter .modal,
.modal-leave-to .modal {
  transform: scale(0.95);
}
</style>
